/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acceptedcount1Inputs */

const de__field_acceptedcount1 = /** @type {(inputs: _Field_Acceptedcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Anmeldungen`)
};

/**

* @param {_Field_Acceptedcount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acceptedcount1 = /** @type {((inputs?: _Field_Acceptedcount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acceptedcount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acceptedcount1(inputs)
});
export { _field_acceptedcount1 as "_field_acceptedCount" }